import { Loader2 } from "lucide-react";

/**
 * Skeleton primitive — animated shimmer block.
 * Use as a placeholder while async data loads.
 *
 * Usage:
 *   <Skeleton className="h-8 w-40" />
 *   <Skeleton variant="circle" className="h-10 w-10" />
 */
export function Skeleton({ className = "", variant = "rect", ...rest }) {
  const radius = variant === "circle" ? "rounded-full" : "rounded-xl";
  return <div className={`tb-skeleton ${radius} ${className}`} {...rest} />;
}

/**
 * SkeletonRow — convenience for list items.
 */
export function SkeletonRow({ lines = 2 }) {
  return (
    <div className="flex items-center gap-3 py-2">
      <Skeleton variant="circle" className="h-9 w-9 shrink-0" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3 w-3/4" />
        {lines > 1 && <Skeleton className="h-3 w-1/2" />}
      </div>
    </div>
  );
}

/**
 * AIThinking — used on AI cards while a generation is streaming.
 */
export function AIThinking({ label = "TeeBee is thinking" }) {
  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 text-primary px-3.5 py-1.5 text-sm">
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
      <span>{label}</span>
      <span className="tb-caret" />
    </div>
  );
}
